module.exports = __webpack_public_path__ + "static/media/акварельное.b6fbc9cb.jpg";